<ng-container *ngIf="isConversationOpen$ | async; else conversationClosedTpl">
  <ng-container *ngIf="composedEmail$ | async as composedEmail">
    <app-genesys-email-outgoing-header
      [model]="composedEmail"
      [displayActions]="false"
      (validate)="onHeaderValidate($event)"
      (headerModelChange)="emailHeaderChange($event)"
    >
    </app-genesys-email-outgoing-header>

    <app-alert-box [editorMessages]="editorMessages$ | async" (closeHandler)="clearEditorMessages()"></app-alert-box>

    <ng-container *ngIf="isFocused">
      <app-genesys-email-editor
        class="gc-email-footer-proactive-editor"
        [conversationId]="conversationId"
        [htmlBody]="composedEmail?.htmlBody"
        [draftAttachments]="draftEmail?.attachments"
        [showQuoteButton]="false"
        (editorSetupDone)="onEditorSetupDone($event)"
        (editorContentChange)="editorContentChanged($event)"
      ></app-genesys-email-editor>

      <div class="bc-email-control-panel">
        <div class="gc-email-footer-proactive-buttons">
          <button
            [disabled]="isInteractionDisabled$ | async"
            (click)="onSend(composedEmail)"
            data-automation-id="gc-email-footer-on-send-button"
            class="btn btn-dark"
          >
            <span>{{ 'genesysProactiveEmail.send' | translate }}</span>
          </button>

          <app-genesys-email-attachment-button
            [disabled]="isInteractionDisabled$ | async"
            [conversationId]="conversationId"
            (sizeLimitError)="onAttachmentSizeLimitError($event)"
          ></app-genesys-email-attachment-button>

          <button
            [disabled]="isInteractionDisabled$ | async"
            (click)="handleConfirmation()"
            data-automation-id="gc-email-footer-close-now-button"
            class="btn btn-light"
          >
            <span>{{ 'genesysProactiveEmail.closeNow' | translate }}</span>
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <app-genesys-email-close-confirmation-modal
    *ngIf="isConfirmationModalVisible$ | async"
    [conversationId]="conversationId"
    (closeConfirmationModal)="closeConfirmation()"
  ></app-genesys-email-close-confirmation-modal>
</ng-container>

<ng-template #conversationClosedTpl>
  <app-genesys-email-wrapup-panel
    class="gc-email-footer-proactive-wrapup"
    [conversationId]="conversationId"
  ></app-genesys-email-wrapup-panel>
</ng-template>
